var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CustomTable", {
        attrs: {
          data: _vm.newTableData,
          header: _vm.tableHeader,
          settings: {
            isLoading: _vm.loading,
            currentPage: _vm.pageNum,
            pageSize: _vm.pageSize,
            total: _vm.total
          }
        },
        on: {
          pageSizeChange: _vm.handleSizeChange,
          currentPageChange: _vm.handleCurrentChange
        },
        scopedSlots: _vm._u([
          {
            key: "fujian",
            fn: function(data) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.openAnnTemList(data.scope.row.templateId)
                      }
                    }
                  },
                  [_vm._v("查看附件模板")]
                )
              ]
            }
          },
          {
            key: "doc",
            fn: function(data) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.openDocList(
                          data.scope.row.templateId,
                          data.scope.row.notaryStatus
                        )
                      }
                    }
                  },
                  [_vm._v("查看公证文书模板")]
                )
              ]
            }
          },
          {
            key: "action",
            fn: function(data) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.openDetails(
                          data.scope.row.templateId,
                          data.scope.row.notaryStatus
                        )
                      }
                    }
                  },
                  [_vm._v("查看模板")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      disabled: data.scope.row.notaryStatus == 3
                    },
                    on: {
                      click: function($event) {
                        return _vm.onPass(data.scope.row.templateId)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        data.scope.row.notaryStatus == 3 ? "已审核" : "审核通过"
                      )
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "danger",
                      size: "small",
                      disabled: data.scope.row.notaryStatus == 3
                    },
                    on: {
                      click: function($event) {
                        return _vm.onReject(data.scope.row.templateId)
                      }
                    }
                  },
                  [_vm._v("驳回")]
                )
              ]
            }
          }
        ])
      }),
      _c("TemDetails", { ref: "temDetails", on: { updateList: _vm.getList } }),
      _c("PassDialog", {
        ref: "passDialog",
        attrs: { templateId: _vm.templateId },
        on: { passSuccess: _vm.getList }
      }),
      _c("RejectDialog", {
        ref: "rejectDialog",
        attrs: { templateId: _vm.templateId },
        on: { submited: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }